const SET_SESSION = async (state, res) => {
  state.session.push(res)
}

const defaultmutation = async (state, res) => {}

const SET_TALK = async (state, res) => {}

export { SET_SESSION, defaultmutation }
